import { UserRoleClientList } from '../enums/user-role.enum';
import { IUser } from '../interfaces/user.interface';

export function isUser(user: { role: string } | null | undefined): user is IUser {
  return Boolean(user) && UserRoleClientList.includes((user as IUser).role);
}
